import classes from './RefreshBubble.module.css'
import { ReactComponent as CloseButton } from '../../../../../assests/chat/bina-close-bubble-button.svg';
import { useDispatch, useSelector } from 'react-redux';
import { restartSession } from '../../../../../store/chatAi-actions';



function RefreshBubble(props) {
    const dispatch = useDispatch()
    const { texts } = useSelector(state => state.translate);

    const onRefresh = () => {
        dispatch(restartSession())
        props.onClose()
    }

    return (
        <>
        <div className={classes.Overlay} onClick={props.onClose}></div>
        <div className={classes.RefreshBubble}>
            <div className={classes.BubbleTitleLine}>
                <div className={classes.BubbleCloseButton} onClick={props.onClose}>
                    <CloseButton />
                </div>
                <div className={classes.BubbleTitleContainer}>
                    <div className={classes.BubbleTitle}>
                        {texts.newConversation}
                    </div>
                </div>
            </div>
            <div className={classes.RefreshText}>
                <span style={{color: "black"}}>{texts.newConversationText}</span>
            </div>
            <div className={classes.RefreshActions}>
                <button alt={texts.cancellation} className={classes.CancelButton} onClick={props.onClose}>
                    {texts.cancellation}
                </button>
                <button alt={texts.newConversation} className={classes.RefreshButton} onClick={onRefresh}>
                    {texts.newConversation}
                </button>
            </div>
        </div>
    </>
    );
}

export default RefreshBubble;